import { FC, ReactNode } from "react";
import LayoutHeader from "./Header";

export interface IFullLayoutProps {
  onSearchChange?: (field: "search", value: string) => void;
  header?: ReactNode;
  children: ReactNode;
}

const FullLayout: FC<IFullLayoutProps> = ({ header, children }) => {
  return (
    <div className="w-full min-h-screen bg-blue-100 text-blue-900 relative">
      <LayoutHeader>{header}</LayoutHeader>

      <div className="px-2 py-2">{children}</div>
    </div>
  );
};

export default FullLayout;
